import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle, theme } from './styles/GlobalStyles';
import Navbar from './components/Navigation/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';

// Compliance Pages
import PCIDSS from './pages/Compliance/PCIDSS';
import ISO27001 from './pages/Compliance/ISO27001';
import CBJCompliance from './pages/Compliance/CBJCompliance';
import WebRiskMonitoring from './pages/Compliance/WebRiskMonitoring';

// Services Pages
import RiskAssessment from './pages/Services/RiskAssessment';
import DataClassification from './pages/Services/DataClassification';
import PoliciesProcedures from './pages/Services/PoliciesProcedures';
import DataflowDiagrams from './pages/Services/DataflowDiagrams';
import SecurityCodeReview from './pages/Services/SecurityCodeReview';

// Vulnerability Management Pages
import VulnerabilityScanning from './pages/Vulnerability/VulnerabilityScanning';
import PenetrationTesting from './pages/Vulnerability/PenetrationTesting';
import RedTeaming from './pages/Vulnerability/RedTeaming';
import SASTDAST from './pages/Vulnerability/SASTDAST';

// Technology Pages
import EDR from './pages/Technologies/EDR';
import NDR from './pages/Technologies/NDR';
import DLP from './pages/Technologies/DLP';
import SecurityAwareness from './pages/Technologies/SecurityAwareness';
import SIEM from './pages/Technologies/SIEM';
import WAF from './pages/Technologies/WAF';
import PAM from './pages/Technologies/PAM';
import NAC from './pages/Technologies/NAC';
import DatabaseSecurity from './pages/Technologies/DatabaseSecurity';

// Managed Services Pages
import SOCServices from './pages/ManagedServices/SOCServices';
import NOCServices from './pages/ManagedServices/NOCServices';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalStyle />
        <div className="App">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              
              {/* Compliance Routes */}
              <Route path="/compliance/pci-dss" element={<PCIDSS />} />
              <Route path="/compliance/iso-27001" element={<ISO27001 />} />
              <Route path="/compliance/cbj-compliance" element={<CBJCompliance />} />
              <Route path="/compliance/web-risk-monitoring" element={<WebRiskMonitoring />} />
              
              {/* Services Routes */}
              <Route path="/services/risk-assessment" element={<RiskAssessment />} />
              <Route path="/services/data-classification" element={<DataClassification />} />
              <Route path="/services/policies-procedures" element={<PoliciesProcedures />} />
              <Route path="/services/dataflow-diagrams" element={<DataflowDiagrams />} />
              <Route path="/services/security-code-review" element={<SecurityCodeReview />} />
              
              {/* Vulnerability Management Routes */}
              <Route path="/vulnerability/scanning" element={<VulnerabilityScanning />} />
              <Route path="/vulnerability/penetration-testing" element={<PenetrationTesting />} />
              <Route path="/vulnerability/red-teaming" element={<RedTeaming />} />
              <Route path="/vulnerability/sast-dast" element={<SASTDAST />} />
              
              {/* Technology Routes */}
              <Route path="/technologies/edr" element={<EDR />} />
              <Route path="/technologies/ndr" element={<NDR />} />
              <Route path="/technologies/dlp" element={<DLP />} />
              <Route path="/technologies/security-awareness" element={<SecurityAwareness />} />
              <Route path="/technologies/siem" element={<SIEM />} />
              <Route path="/technologies/waf" element={<WAF />} />
              <Route path="/technologies/pam" element={<PAM />} />
              <Route path="/technologies/nac" element={<NAC />} />
              <Route path="/technologies/database-security" element={<DatabaseSecurity />} />
              
              {/* Managed Services Routes */}
              <Route path="/managed-services/soc" element={<SOCServices />} />
              <Route path="/managed-services/noc" element={<NOCServices />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;

